export default __webpack_public_path__ + "static/media/lock.99b08be0.svg";